// extracted by mini-css-extract-plugin
export default {"form":"CheckOut_form__FBR6V","control":"CheckOut_control__MMHjP","actions":"CheckOut_actions__d0Yev","submit":"CheckOut_submit__7WhM-","invalid":"CheckOut_invalid__atoUi"};